export type AppRole = "admin" | "super_admin" | "patient" | "clinician" | string;

export function getHomePathForRoles(roles: AppRole[]): "/admin" | "/paciente/minha-saude" | "/app" {
  if (roles.includes("admin") || roles.includes("super_admin")) {
    return "/admin";
  }

  if (roles.includes("patient")) {
    return "/paciente/minha-saude";
  }

  return "/app";
}
